import Vue from "vue";
import { vuexfireMutations, firestoreAction } from "vuexfire";
import Vuex from "vuex";
import { firestore } from "@/firebase/firestore";
import i18n from "@/i18n";
import router from "@/router";

import Product from "@/model/product.js";
import Category from "@/model/category.js";
import Allergen from "@/model/allergen";
import Option from "@/model/option";
import { Order, OrderProductStatus } from "@/model/order";
import Restaurant from "@/model/restaurant";
import Location from "@/model/location";
import AuthService from "../service/auth_service";
import StripePlan from "../model/stripe_plan";

Vue.use(Vuex);

// let menuId = "2fQz0RTKaECzMYoJwaXx";
// let restaurantId = "FFMMSHUAsVFfSJYlrn6m";
// TODO What's the point of this commented code? Is it ever gonna be used?
// let myref = firestore
//   .collection("/menus/2fQz0RTKaECzMYoJwaXx/products/")
//   .doc("1xUO8dG1XvdklSUFi5N4");

const store = new Vuex.Store({
  state: {
    products: [],
    categories: [],
    locales: [],
    locations: [],
    restaurants: [],
    productPlans: [],
    staff: [],
    roles: [],
    orders: [],
    activities: [],
    menu: null,
    notifications: {},
    promiseLoading: null,
    dispatched: false,
    showDrawer: false,
    accountDetails: {},
    notifyToken: ""
  },

  mutations: {
    ...vuexfireMutations,
    set(state, data) {
      Vue.set(state, data.varName, data.value);
    }
  },
  actions: {
    bindActivities: firestoreAction(({ getters, bindFirestoreRef }) => {
      return bindFirestoreRef(
        "activities",
        firestore
          .collection(`/restaurants/${getters.restaurant.id}/activities/`)
          .orderBy("date", "desc")
      );
    }),
    bindProducts: firestoreAction(({ getters, bindFirestoreRef }) => {
      return bindFirestoreRef(
        "products",
        firestore.collection(`/restaurants/${getters.restaurant.id}/products/`)
      );
    }),
    bindCategories: firestoreAction(({ getters, bindFirestoreRef }) => {
      return bindFirestoreRef(
        "categories",
        firestore.collection(
          `/restaurants/${getters.restaurant.id}/categories/`
        )
      );
    }),
    bindProductPlans: firestoreAction(({ bindFirestoreRef }) => {
      return bindFirestoreRef(
        "productPlans",
        firestore.collection(`/productPlans/`)
      );
    }),
    // bindLocales: firestoreAction(({ bindFirestoreRef }) => {
    //   return bindFirestoreRef(
    //     "locales",
    //     firestore.collection(`menus/${menuId}/locales/`)
    //   );
    // }),
    bindLocations: firestoreAction(({ getters, bindFirestoreRef }) => {
      return bindFirestoreRef(
        "locations",
        firestore.collection(`restaurants/${getters.restaurant.id}/locations/`)
      );
    }),
    bindRestaurants: firestoreAction(({ bindFirestoreRef }) => {
      return bindFirestoreRef(
        "restaurants",
        firestore
          .collection("restaurants")
          .where("user", "==", AuthService.info.id)
      );
      // firestore.collection("restaurants").doc(restaurantId)
    }),
    // bindStaff: firestoreAction(({ getters, bindFirestoreRef }) => {
    //   return bindFirestoreRef(
    //     "staff",
    //     firestore.collection(`/restaurants/${getters.restaurant.id}/staff/`)
    //   );
    // }),
    // bindRoles: firestoreAction(({ getters, bindFirestoreRef }) => {
    //   return bindFirestoreRef(
    //     "roles",
    //     firestore.collection(`/restaurants/${getters.restaurant.id}/roles/`)
    //   );
    // }),
    bindOrders: firestoreAction(({ getters, bindFirestoreRef }) => {
      return bindFirestoreRef(
        "orders",
        firestore
          .collection(`/restaurants/${getters.restaurant.id}/orders/`)
          .where(
            "date",
            ">",
            new Date(new Date().setDate(new Date().getDate() - 1)) //Only last day
          )
      );
    }),
    bindAccountDetails: firestoreAction(({ getters, bindFirestoreRef }) => {
      return bindFirestoreRef(
        "accountDetails",
        firestore
          .collection(`/restaurants/${getters.restaurant.id}/accountDetails/`)
          .doc("1")
      );
    })
  },

  getters: {
    locale: (_, getters) => {
      return getters.getLocaleByLang("es");
    },
    notifyToken: state => {
      return state.notifyToken;
    },

    getLocaleByLang: state => lang => {
      return state.locales.find(locale => locale.id === lang);
    },

    isReady: (_, getters) => {
      if (
        // TODO Add commented out properties to isReady when possible
        // getters.locale &&
        getters.products &&
        getters.categories &&
        getters.orders &&
        getters.restaurant &&
        getters.locations &&
        getters.accountDetails
        // getters.menu &&
        //
        // getters.mapImage
      ) {
        return true;
      } else {
        // console.log("getters.products ", getters.products);
        // console.log("getters.categories ", getters.categories);
        // console.log("getters.orders ", getters.orders);
        // console.log("getters.restaurant ", getters.restaurant);
        // console.log("getters.locations", getters.locations);
        return false;
      }
    },

    locations: state => {
      // TODO forEach, then sort to return col.map(...).sort(...)?
      let locations = [];
      state.locations.forEach(storeLocations => {
        locations.push(
          Location.fromMap({
            ...storeLocations,
            restaurantId: store.getters.restaurant.id,
            id: storeLocations.id
          })
        );
      });
      return locations.sort(function(a, b) {
        if (a.name > b.name) {
          return 1;
        }
        if (b.name > a.name) {
          return -1;
        }
        return 0;
      });
    },

    staff: state => {
      let staff = [];
      state.staff.forEach(storeStaff => {
        staff.push({
          ...storeStaff,
          id: storeStaff.id
        });
      });
      return staff.sort(function(a, b) {
        if (a.name > b.name) {
          return 1;
        }
        if (b.name > a.name) {
          return -1;
        }
        return 0;
      });
    },

    roles: state => {
      let roles = [];
      state.roles.forEach(storeRoles => {
        roles.push({
          ...storeRoles,
          id: storeRoles.id
        });
      });
      return roles.sort(function(a, b) {
        if (a.name > b.name) {
          return 1;
        }
        if (b.name > a.name) {
          return -1;
        }
        return 0;
      });
    },

    mapImage: state => {
      return state.restaurant.mapImage;
    },
    accountDetails: state => {
      return state.accountDetails;
    },
    accountType: state => {
      if (!state.accountDetails) {
        router.replace("/signup");
      } else {
        if (state.accountDetails.type == "prod_HbdeY25CjHvX9A") {
          return "basic";
        } else if (state.accountDetails.type == "prod_HbdaxqlYfsUavV") {
          return "standard";
        } else if (state.accountDetails.type == "free") {
          return "free";
        }
        return "none";
      }
    },
    isActive: state => {
      return state.accountDetails ? !!state.accountDetails.isActive : false;
    },
    maxLocations: (_, getters) => {
      if (getters.accountType == "basic") {
        return 50;
      } else if (getters.accountType == "standard") {
        return 100;
      } else if (getters.accountType == "free") {
        return 1000;
      }
      return 0;
    },
    canCreateLocation: (_, getters) => {
      return getters.locations.length < getters.maxLocations;
    },
    canOrder: (_, getters) => {
      return getters.accountType == "basic" ? false : true;
    },

    products: state => {
      let products = [];
      state.products.forEach(storeProduct => {
        let product = new Product(storeProduct);
        product.allergens = storeProduct.allergens.map(
          allergen => new Allergen(allergen)
        );
        product.options = storeProduct.options.map(
          option => new Option(option)
        );
        products.push(product);
      });
      return products.sort((a, b) => a.index - b.index);
    },

    categories: state => {
      let categories = [];
      state.categories.forEach(storeCategory => {
        let category = new Category(storeCategory);
        categories.push(category);
      });
      return categories;
    },
    plans: state => {
      let plans = [];
      state.productPlans.forEach(storePlan => {
        let plan = new StripePlan(storePlan);
        plans.push(plan);
      });
      return plans;
    },

    orders: state => state.orders.map(storeOrder => Order.fromMap(storeOrder)),

    restaurant: state => {
      return state.restaurants[0]
        ? Restaurant.fromMap(state.restaurants[0])
        : null;
    },

    menu: (_, getters) => {
      let menu = {};
      let withoutCategoryId = -2;
      let allProductsId = -1;
      let categoryList = [...getters.categories];
      let products = getters.products;

      // Create allProduducts and noCategoryProducts for menu
      let allProductsCat = new Category({
        id: allProductsId,
        restaurantId: getters.restaurant.id,
        name: i18n.t("All products"),
        index: -2
      });
      let noCategory = new Category({
        id: withoutCategoryId,
        restaurantId: getters.restaurant.id,
        name: i18n.t("Without category"),
        index: -1
      });
      categoryList.push(allProductsCat);
      categoryList.push(noCategory);

      categoryList.forEach(category => {
        menu[category.id] = {
          name: category.name,
          products: [],
          id: category.id,
          index: category.index || 0
        };
      });

      products.forEach(product => {
        let category =
          product.category && menu[product.category]
            ? product.category
            : withoutCategoryId;
        menu[category].products.push(product);
        menu[allProductsId].products.push(product);
      });

      return Object.values(menu).sort(function(a, b) {
        return a.index - b.index;
      });
    },

    menuConsumer: (_, getters) => {
      let menu = {};
      let withoutCategoryId = 0;
      let categoryList = [...getters.categories];
      let products = getters.products;
      categoryList.push({
        name: i18n.t(""),
        description: "",
        id: withoutCategoryId
      });
      categoryList.forEach(category => {
        menu[category.id] = {
          name: category.name,
          description: category.description,
          products: []
        };
      });
      for (let productIndex in products) {
        let product = products[productIndex];
        if (product.categories.length > 0) {
          for (let category in product.categories) {
            if (menu[product.categories[category].id]) {
              menu[product.categories[category].id].products.push(product);
            }
          }
        } else {
          menu[withoutCategoryId].products.push(product);
        }
      }

      return menu;
    }
  }
});

const whenRestaurantIsReady = async fn => {
  if (store.getters.restaurant && store.getters.restaurant.id) {
    return fn();
  }
  setTimeout(async () => await whenRestaurantIsReady(fn), 500);
};

const acceptPendingOrders = orders => {
  if (store.getters.restaurant.acceptOrdersAuto) {
    let ordersToSave = [];
    orders.forEach(order => {
      let atLeastOneIsPending = false;
      order.products.forEach(product => {
        if (product.status === OrderProductStatus.pending) {
          product.status = OrderProductStatus.preparing;
          atLeastOneIsPending = true;
        }
      });
      {
        if (atLeastOneIsPending) {
          ordersToSave.push(order);
        }
      }
      if (ordersToSave) {
        ordersToSave.forEach(order => order.save());
      }
    });
  }
};

AuthService.onAuthStateChanged(async user => {
  if (user && !store.state.dispatched) {
    store.dispatch("bindRestaurants");
    whenRestaurantIsReady(() => {
      store.dispatch("bindAccountDetails");
      store.dispatch("bindCategories");
      store.dispatch("bindProducts");
      store.dispatch("bindLocations");
      store.dispatch("bindOrders");
      store.dispatch("bindActivities");
      store.state.dispatched = true;

      // Set up watcher to autoaccept pending orders
      store.watch(
        (_, getters) => getters.orders,
        newOrders => acceptPendingOrders(newOrders)
      );

      // mapMutationsup watcher for when updating acceptOrdersAuto
      store.watch(
        (_, getters) => getters.restaurant,
        newRestaurant => {
          if (newRestaurant.acceptOrdersAuto) {
            acceptPendingOrders(store.getters.orders);
          }
        }
      );
    });
  }
});

export default store;
